import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AjaxResponseInterface } from 'src/app/interface/global/AjaxResponseInterface';
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnitService {
  private unitBaseUrl: string = environment.apiUrl + "/unit";
  constructor(private http: HttpClient) { }

  isUnitNotAssignedToAnyTracker(unitId:string): Observable<AjaxResponseInterface<boolean>> {
    return this.http.get<AjaxResponseInterface<boolean>>(this.unitBaseUrl + "/does-unit-not-exist-in-trackers?_id=" + unitId);
  }
}